// @ts-nocheck
import Illustration from './Illustration'
import './Illustration.scss'
export default Illustration
